import { IconButton } from '@melio/penny';

export const SyncNowIconButton = ({
  onClick,
  isDisabled,
  ariaLabel,
}: {
  onClick: VoidFunction;
  isDisabled: boolean;
  ariaLabel: string;
}) => (
  <IconButton
    aria-label={ariaLabel}
    icon="refresh"
    onClick={onClick}
    size="large"
    variant="naked"
    isDisabled={isDisabled}
    data-testid="sync-now-button"
    data-tourid="sync-now-button"
  />
);
